import {
  faArrowUpRightFromSquare,
  faFileLines,
} from "@fortawesome/pro-regular-svg-icons";
import { Box } from "@mui/material";

import { Icon } from "@/components/ui-v2";

import { PrimaryNavigationItemBase } from "../../../PrimaryNavigationLinks/components/PrimaryNavigationLink/components/PrimaryNavigationItemBase";

export const ApiDocsButton = () => {
  const iconComponent = (
    <Box
      sx={{
        height: 36,
        width: 36,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Icon icon={faFileLines} size="medium" />
    </Box>
  );

  const endIcon = (
    <Box
      sx={{
        height: 36,
        width: 36,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Icon icon={faArrowUpRightFromSquare} />
    </Box>
  );

  return (
    <PrimaryNavigationItemBase
      as="a"
      id="api-docs-button"
      icon={iconComponent}
      label="API Docs"
      style={{
        width: "100%",
      }}
      href="https://layer.ai/docs"
      target="_blank"
    >
      {endIcon}
    </PrimaryNavigationItemBase>
  );
};
